import React from 'react';
import {motion} from 'motion/react';
import {TRANSITIONS} from '@/config/animations';

interface VideoSliderProps {
    show: boolean;
    direction?: 'up' | 'down';
    children: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
}

const VideoSlider: React.FC<VideoSliderProps> = ({
                                                     show,
                                                     direction = 'up',
                                                     children,
                                                     style,
                                                     className,
                                                 }) => {
    const getTranslateY = () => {
        if (show) return '0%';
        return direction === 'up' ? '-100%' : '100%';
    };

    return (
        <motion.div
            className={className}
            style={{
                position: 'absolute',
                inset: 0,
                width: '100vw',
                height: '100vh',
                overflow: 'hidden',
                ...style,
            }}
            initial={{translateY: getTranslateY()}}
            animate={{translateY: getTranslateY()}}
            transition={TRANSITIONS.slow}
        >
            {children}
        </motion.div>
    );
};

export default VideoSlider;
